import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-ascii-doc',
  standalone: true,
  imports: [],
  templateUrl: './ascii-doc.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ascii-doc.component.scss'
})
export class AsciiDocComponent {

}
